import { EnvUtil } from './env-util';

export const generateBenchUrl = accountId =>
  `${EnvUtil.clientUrl}/account/${accountId}/my-bench`;
export const generateAFCProjectsMatchesUrl = (accountId, submissionId) =>
  `${EnvUtil.clientUrl}/account/${accountId}/submission/${submissionId}/matches`;
export const generateAFCLandingPageUrl = accountId =>
  `${EnvUtil.clientUrl}/account/${accountId}`;
